import {UpdateUserResponse} from '@services/UserService'
import {OperatorRecevabilityStage} from './OperatorsAndPsaps'
import {Href, HrefTemplated} from "@interfaces/Paginations";

export interface UserDetails {
  name: string
  operator?: OperatorInterface
  role: RoleInterface
  login: string
  contactMail: string
  firstName: string
  psap?: PsapInUserDetails
  _links: UserLinksInterface
}

export interface UserLinksInterface {
  self: Href
  user: HrefTemplated
  role: HrefTemplated
  psapsForLoginMinisterProjectChief: HrefTemplated
  psap: HrefTemplated
  operator: HrefTemplated
  psapsForLoginPsapIntegrator: HrefTemplated
}
export interface RoleInterface {
  name: string
  roleId: string
  _links: {
    rightCreation: Href
    rights: Href
    users: HrefTemplated
    self: HrefTemplated
    role?: HrefTemplated
  }
}

export interface Roles {
  _embedded: {
    roles: RoleInterface[]
  }
}
export interface PsapInUserDetails {
  psapId: string
  status: string
  psapIntegrator?: PsapIntegrator
  isSvh: boolean
  statusSvh: string
  _links: {
    pullPsaps: Href
    users: HrefTemplated
    commonName: Href
    sslInfos: HrefTemplated
    agregStatsPsapPullReqPics: Href
    psapIntegrator: HrefTemplated
    numLongPsaps: HrefTemplated
    statsTerminalLocations: Href
    agregStatsPsapReqNumLongs: Href
    agregStatsPsapReqHeures: Href
    ministerProjectChief: HrefTemplated
    psapRecevability: HrefTemplated
    blockedPsaps: Href
    self: HrefTemplated
  }
}

export interface PsapIntegrator {
  name: string
  login: string
  firstName: string
  _links: {
    role: HrefTemplated
    psapsForLoginMinisterProjectChief: HrefTemplated
    psap: HrefTemplated
    operator: HrefTemplated
    psapsForLoginPsapIntegrator: HrefTemplated
    self: HrefTemplated
  }
}
export interface OperatorInterface {
  getLocationSvhUrl: string
  arcepOperatorId: string
  isOpta: boolean
  getAddressSvhUrl: string
  getAddressUrl: string
  status: string
  notifyOperatorUrl?: string
  contactMail: string
  startScheduledMaintenance?: string
  endScheduledMaintenance?: string
  operatorRecevabilityStage?: OperatorRecevabilityStage
  dateUpdateStatus?: string
  addressesIp: string
  slaGetAddressTimeResponse: number
  isMno: boolean
  useRebound: boolean
  msgScheduledMaintenance?: string
  isSvh: boolean
  operReseauSvh?: string
  _links: {
    statsSlaPushlocations: Href
    statsSlaGetaddresses: Href
    agregStatsOperators: Href
    statsSlaGetlocationSVHs: Href
    operators: HrefTemplated
    users: HrefTemplated
    operatorRecevabilityStage: HrefTemplated
    vpnInfos: Href
    operator: HrefTemplated[]
    operatorRecevability: HrefTemplated
    self: HrefTemplated
  }
}

export enum OperatorStatus {
  RECEVABILITY_IN_PROGRESS = 'RECEVABILITY_IN_PROGRESS',
  RECEVABILITY_DONE = 'RECEVABILITY_DONE',
  IN_PRODUCTION = 'IN_PRODUCTION',
  IN_SERVICE = 'IN_SERVICE',
  DEACTIVATED = 'DEACTIVATED'
}
export enum PsapStatus {
  CREATED_WITH_CAAU = 'CREATED_WITH_CAAU',
  RECEVABILITY_IN_PROGRESS = 'RECEVABILITY_IN_PROGRESS',
  RECEVABILITY_DONE = 'RECEVABILITY_DONE',
  IN_PRODUCTION = 'IN_PRODUCTION',
  IN_SERVICE = 'IN_SERVICE',
  DEACTIVATED = 'DEACTIVATED'
}
export enum Role {
  OPERATOR = 'OPERATOR',
  OPERATOR_MANAGER = 'OPERATOR_MANAGER',
  OPERATOR_MANAGER_RECEVABILITY = 'OPERATOR_MANAGER_RECEVABILITE',
  PSAP = 'PSAP',
  PSAP_MANAGER = 'PSAP_MANAGER',
  PSAP_INTEGRATOR = 'PSAP_INTEGRATOR',
  MINIST_PROJECT_MANAGER = 'MINIST_PROJECT_MANAGER',
  STATE_AUTHORITY = 'STATE_AUTHORITY',
  ADMIN_APNF = 'ADMIN_APNF',
  ADMIN_APNF_RECEVABILITY = 'ADMIN_APNF_RECEVABILITY',
  WORLDLINE = 'WORLDLINE',
  SUPER_ADMIN = 'SUPER_ADMIN'
}

export function mapUpdateUserResponseToUserDetails(
  updateUserResponse: UpdateUserResponse
): UserDetails {
  return {
    name: updateUserResponse.name,
    role: {
      name: '',
      roleId: '',
      _links: {
        rightCreation: {
          href: updateUserResponse._links.role.href
        },
        rights: {
          href: ''
        },
        self: {
          href: updateUserResponse._links.role.href,
          templated: updateUserResponse._links.role.templated
        },
        users: {
          href: '',
          templated: false
        },
        role: {
          href: updateUserResponse._links.role.href,
          templated: updateUserResponse._links.role.templated
        }
      }
    },
    login: updateUserResponse.login,
    contactMail: updateUserResponse.contactMail,
    firstName: updateUserResponse.firstName,
    _links: {
      self: {
        href: updateUserResponse._links.self.href
      },
      user: {
        href: updateUserResponse._links.user.href,
        templated: updateUserResponse._links.user.templated
      },
      role: {
        href: updateUserResponse._links.role.href,
        templated: updateUserResponse._links.role.templated
      },
      psapsForLoginMinisterProjectChief: {
        href: updateUserResponse._links.psapsForLoginMinisterProjectChief.href,
        templated:
          updateUserResponse._links.psapsForLoginMinisterProjectChief.templated
      },
      psap: {
        href: updateUserResponse._links.psap.href,
        templated: updateUserResponse._links.psap.templated
      },
      operator: {
        href: updateUserResponse._links.operator.href,
        templated: updateUserResponse._links.operator.templated
      },
      psapsForLoginPsapIntegrator: {
        href: updateUserResponse._links.psapsForLoginPsapIntegrator.href,
        templated:
          updateUserResponse._links.psapsForLoginPsapIntegrator.templated
      }
    }
  }
}
